import {PAGE_UPDATED} from "./types";

export const updatePage = (title, subtitle = null) => dispatch => {
    dispatch({ type: PAGE_UPDATED, payload: { title: title, subtitle: subtitle } });
};